import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ClientsService } from '../../../../services/customers/clients.service';
import { MarkerClusterer, MarkerUtils, Renderer } from "@googlemaps/markerclusterer";
import { CustomerActiveStatus } from '../../../../constants/customers.enum';
// Importa o define aquí tu clase MyCustomRenderer
class MyCustomRenderer implements Renderer {
  private getPopulationColor(count: number, maxCount: number): string {
    // Calcular rangos dinámicamente basándose en la cantidad máxima
    const lowThreshold = Math.ceil(maxCount * 0.33);  // 33% del máximo
    const highThreshold = Math.ceil(maxCount * 0.66); // 66% del máximo

    // Verde para cantidades bajas (0-33% del máximo)
    if (count <= lowThreshold) return '#4CAF50';
    // Naranja para cantidades medias (34-66% del máximo)
    if (count <= highThreshold) return '#FF9800';
    // Rojo para cantidades altas (67-100% del máximo)
    return '#F44336';
  }
  render({ count, position }: any, stats: any, map: any) {

    // change color if this cluster has more markers than the mean cluster
    const color = this.getPopulationColor(count, stats.clusters.markers.max);
    // create svg literal with fill color
    const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="70" height="70">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
    const title = `${count} Clients`,
      // adjust zIndex to be above other markers
      zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
    if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
      // create cluster SVG element
      const parser = new DOMParser();
      const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
      svgEl.setAttribute("transform", "translate(0 25)");
      const clusterOptions = {
        map,
        position,
        zIndex,
        title,
        content: svgEl,
      };
      return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
    }
    const clusterOptions = {
      position,
      zIndex,
      title,
      icon: {
        url: `data:image/svg+xml;base64,${btoa(svg)}`,
        anchor: new google.maps.Point(25, 25),
      },
    };
    return new google.maps.Marker(clusterOptions);
  }
}

interface MarkerData {
  position: google.maps.LatLngLiteral;
  title: string;
  options: google.maps.MarkerOptions;
  client: any;
}

@Component({
    selector: 'app-clients-map-locations',
    templateUrl: './clients-map-locations.component.html',
    styleUrls: ['./clients-map-locations.component.scss'],
    standalone: false
})
export class ClientsMapLocationsComponent implements AfterViewInit {
  styles = [
    {
      "featureType": "all",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ]
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef | undefined
  isLoading: boolean = true;
  totalClients: number = 0;
  defaultCenter: google.maps.LatLngLiteral = { lat: 28.3185375, lng: -81.3950552 };
  defaultZoom = 6;
  mapOptions: google.maps.MapOptions = {
    center: this.defaultCenter,
    zoom: this.defaultZoom,
    mapTypeId: 'roadmap' as google.maps.MapTypeId,
    zoomControl: true,
    scrollwheel: true,
    disableDoubleClickZoom: false,
    maxZoom: 20,
    minZoom: 3,
    styles: this.styles
  };
  map: google.maps.Map | undefined;
  markerClusterer: MarkerClusterer | undefined;
  allClientsWithLocations: any[] = [];
  allMarkers: google.maps.Marker[] = [];
  infoWindow: google.maps.InfoWindow | undefined;

  constructor(private clientsService: ClientsService, private router: Router) { }

  ngAfterViewInit(): void {
    this.initMap();
  }

  initMap(): void {
    const mapOptions: google.maps.MapOptions = this.mapOptions;
    this.map = new google.maps.Map(this.gmap?.nativeElement, mapOptions);
    this.loadCustomers();
  }

  addMarkers(clientsWithLocations: any[]): void {
    if (this.markerClusterer) {
      this.markerClusterer.clearMarkers();
    }
    if (this.allMarkers && this.allMarkers.length > 0) {
      this.allMarkers.forEach(m => m.setMap(null));
    }

    const markers = clientsWithLocations.map((clientLocation: any) => {
      const marker = new google.maps.Marker({
        position: { lat: clientLocation.lat, lng: clientLocation.lng },
        map: this.map,
        title: clientLocation.client.name_client || 'Cliente'
      });

      // Agregar event listener para el clic en el marcador
      marker.addListener('click', () => {
        this.onMarkerClick({
          position: { lat: clientLocation.lat, lng: clientLocation.lng },
          title: clientLocation.client.name_client || 'Cliente',
          options: {},
          client: clientLocation.client
        }, marker);
      });

      return marker;
    });

    this.allMarkers = markers;

    // Crea la instancia de MarkerClusterer
    const customRenderer: any = new MyCustomRenderer();
    this.markerClusterer = new MarkerClusterer({
      map: this.map,
      markers: markers,
      renderer: customRenderer
    });
  }

  onSearch(term: string): void {
    if (!term) {
      this.addMarkers(this.allClientsWithLocations);
      this.totalClients = this.allClientsWithLocations.length;
      return;
    }

    const lowerTerm = term.toLowerCase();
    const filtered = this.allClientsWithLocations.filter(c => {
      const client = c.client;
      return (client.ident_GUI && client.ident_GUI.toLowerCase().includes(lowerTerm)) ||
             (client.name_client && client.name_client.toLowerCase().includes(lowerTerm)) ||
             (client.address && client.address.toLowerCase().includes(lowerTerm));
    });

    this.addMarkers(filtered);
    this.totalClients = filtered.length;
  }

  onMarkerClick(markerData: MarkerData, marker: google.maps.Marker): void {
    const popupDiv = document.createElement('div');
    popupDiv.className = 'premium-pin-card';

    const isActive = markerData.client.active !== false;
    const statusClass = isActive ? 'status-active' : 'status-inactive';
    const statusText = isActive ? 'Active Client' : 'Inactive Client';

    popupDiv.innerHTML = `
      <div class="card-header-sleek">
        <div class="header-icon-wrapper">
          <i class="mdi mdi-storefront-outline"></i>
        </div>
        <div class="header-title-wrapper">
          <h3 class="restaurant-name text-capitalize">${markerData.client.name_client || 'Unknown Restaurant'}</h3>
          <span class="badge-status ${statusClass}">${statusText}</span>
        </div>
      </div>

      <div class="card-divider"></div>

      <div class="card-body-sleek">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label"><i class="mdi mdi-identifier"></i> ID</span>
            <span class="info-val">${markerData.client.ident_GUI || '-'}</span>
          </div>
          <div class="info-item">
            <span class="info-label"><i class="mdi mdi-phone-outline"></i> Phone</span>
            <span class="info-val">${markerData.client.phone || '-'}</span>
          </div>
        </div>
        
        <div class="info-item full-width mt-3">
          <span class="info-label"><i class="mdi mdi-map-marker-outline"></i> Address</span>
          <span class="info-val text-wrap">${markerData.client.address || ''}, ${markerData.client.city || ''}, ${markerData.client.state || ''}</span>
        </div>

        <div class="info-item full-width mt-3">
          <span class="info-label"><i class="mdi mdi-account-tie-outline"></i> Sales Rep</span>
          <span class="info-val">${markerData.client.sales_person || 'Unassigned'}</span>
        </div>
      </div>

      <div class="card-footer-sleek">
        <button class="btn-action-premium btn-resume">
          <span>View Full Profile</span>
          <i class="mdi mdi-arrow-right"></i>
        </button>
      </div>
    `;

    const resumeBtn = popupDiv.querySelector('.btn-resume');
    if (resumeBtn) {
      resumeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.router.navigate(['/uco/customer/resume', markerData.client._id]);
      });
    }

    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow();
    }
    this.infoWindow.setContent(popupDiv);

    if (this.map) {
      this.infoWindow.open(this.map, marker);
    }
  }

  createMarker(map: google.maps.Map, lat: number, lng: number) {
    if (MarkerUtils.isAdvancedMarkerAvailable(map)) {
      return new google.maps.marker.AdvancedMarkerElement({
        map,
        position: { lat, lng },
      });
    }

    return new google.maps.Marker({
      position: { lat, lng },
      map,
    });
  }

  loadCustomers(): void {
    this.isLoading = true;
    this.clientsService.getClientsMapLocations().subscribe({
      next: (data: any) => {
        const clientsWithLocations = data.clients?.filter((client: any) => client.geoid?.latitude && client.geoid?.longitude).map((client: any) => {
          return {
            lat: Number(client.geoid?.latitude),
            lng: Number(client.geoid?.longitude),
            client: client
          }
        })
        this.allClientsWithLocations = clientsWithLocations || [];
        this.totalClients = this.allClientsWithLocations.length;
        this.addMarkers(this.allClientsWithLocations);
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      }
    });
  }

  // Método para centrar el mapa
  centerMap(): void {
    if (this.map) {
      this.map.setCenter(this.defaultCenter);
      this.map.setZoom(this.defaultZoom);
    }
  }
}